import React from "react";
import { Controller, Control } from "react-hook-form";
import FormErrorMessage from "../FormErrorMessage/FormErrorMessage";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { EmployerPermissions, GetPartnerRolesQuery, GetPartnerRolesQueryVariables } from "generated/graphql";
import { FormField } from "../FormField/FormField";
import { Option } from "Shared/types/Option";
import { permissionLabels } from "Shared/types/Admins";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

export interface AccessLevelFormSelectProps {
  control: Control;
  showError: boolean;
  assignedValue?: Option;
  disabled?: boolean;
}

export const AccessLevelFormSelect = ({ control, showError, assignedValue, disabled }: AccessLevelFormSelectProps) => {
  const { data } = useQuery<
    GetPartnerRolesQuery,
    GetPartnerRolesQueryVariables
  >(queries.GET_PARTNER_ROLES);

  if (!data) {
    return null;
  }
  const options = data.partnerRoles.items.map(partnerRole => ({
    value: partnerRole.oid.toUpperCase(),
    label: permissionLabels[partnerRole.oid.toUpperCase() as EmployerPermissions],
  }));

  return options.length ? (
    <FormField fieldName="Access Level">
      <Controller
        name="permissions"
        control={control}
        isDisabled={disabled}
        defaultValue={assignedValue || null}
        rules={{ required: true }}
        options={options}
        as={
          <DPReactSelect placeholder="Please select"/>
        }
      />
      <FormErrorMessage
        showError={showError}
        labelFor="permissions"
        message="Please select access level"
      />
    </FormField>
  ) : (
    <></>
  );
};
